import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import TimeseriesSummaryView from '../timeseries/TimeseriesSummaryView'
import * as TimeseriesActionCreators from '../../actions/timeseries'

class UnitTimeseriesSummaryContainer extends React.Component {
  static propTypes = {
    unitId: PropTypes.number.isRequired,
    timeseries: PropTypes.object.isRequired,
    timeseriesByUnit: PropTypes.object.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      timeseries: state.timeseries,
      timeseriesByUnit: state.timeseriesByUnit,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
    }
  }

  componentDidMount() {
    const { unitId, timeseriesActions } = this.props
    timeseriesActions.listUnitTimeseries(unitId)
  }

  onClick = (timeseries) => {
    this.props.history.push(`/units/${timeseries.unit_id}/timeseries/${timeseries.id}`)
  }

  unitId() {
    return this.props.unitId
  }

  unitTimeseries() {
    const {
      timeseries, timeseriesByUnit,
    } = this.props
    const tsIds = timeseriesByUnit[this.unitId()] || []
    const unitTimeseries = []
    tsIds.forEach((id) => {
      unitTimeseries.push(timeseries[id])
    })

    return unitTimeseries
  }

  render() {
    return (
      <TimeseriesSummaryView timeseries={this.unitTimeseries()} onClick={this.onClick} />
    )
  }
}

export default connect(
  UnitTimeseriesSummaryContainer.mapStateToProps,
  UnitTimeseriesSummaryContainer.mapDispatchToProps,
)(withRouter(UnitTimeseriesSummaryContainer))
